import { Checkbox, Radio } from '@mui/material';

import ScrollArea from '@/shared/ui/ScrollArea';

import {
  CheckboxListContainer,
  CheckboxListItem,
  FilterFieldContainer,
  FilterLabel,
  checkboxSx,
  radioSx,
} from '../GeneratikTableFilterPanel.styles';
import { CheckboxListFieldProps } from '../GeneratikTableFilterPanel.types';

const CheckboxListFilterField = ({ field, value, onChange, disabled }: CheckboxListFieldProps) => {
  const multiple = field.multiple !== false;

  const handleToggle = (optionValue: string) => {
    if (multiple) {
      const next = value.includes(optionValue)
        ? (value as string[]).filter((v) => v !== optionValue)
        : [...value, optionValue];
      onChange(next);
    } else {
      onChange(value === optionValue ? '' : optionValue);
    }
  };

  const sortedOptions = (field.options ?? [])
    .slice()
    .sort((a, b) => (a.label ?? '').localeCompare(b.label ?? ''));

  return (
    <FilterFieldContainer data-testid={`filter-field-${field.id}`}>
      <FilterLabel>{field.label}</FilterLabel>
      <CheckboxListContainer data-testid={`filter-field-${field.id}`}>
        <ScrollArea maxHeight="12rem">
          {sortedOptions.map((option) =>
            multiple ? (
              <CheckboxListItem key={option.value}>
                <Checkbox
                  size="small"
                  checked={value.includes(option.value)}
                  onChange={() => handleToggle(option.value)}
                  inputProps={{ 'aria-label': option.label }}
                  sx={checkboxSx}
                  disabled={disabled}
                />
                {option.label}
              </CheckboxListItem>
            ) : (
              <CheckboxListItem key={option.value}>
                <Radio
                  size="small"
                  checked={value.includes(option.value)}
                  onClick={() => handleToggle(option.value)}
                  inputProps={{ 'aria-label': option.label }}
                  sx={radioSx}
                  disabled={disabled}
                />
                {option.label}
              </CheckboxListItem>
            ),
          )}
        </ScrollArea>
      </CheckboxListContainer>
    </FilterFieldContainer>
  );
};

export default CheckboxListFilterField;
